import type { UseFormSetValue } from 'react-hook-form';
import { StyleSheet } from 'react-native-unistyles';
import Avatar from '@/components/Custom/Avatar';
import Chip from '@/components/UI/Chip';
import { type FragmentOf, graphql, readFragment } from '@/gql/graphql';
import type { EventScorekeepingPanelFormValues } from '../../EventScorekeeping.types';

export const EventScorekeepingPanelTeamItemFragment = graphql(/* GraphQL */ `
  fragment EventScorekeepingPanelTeamItem on team {
    id
    title
    home_primary_color
    avatar_id
  }
`);

function EventScorekeepingPanelTeamItem({
  fragment,
  isChecked,
  setValue,
}: {
  fragment: FragmentOf<typeof EventScorekeepingPanelTeamItemFragment>;
  isChecked: boolean;
  setValue: UseFormSetValue<EventScorekeepingPanelFormValues>;
}) {
  const team = readFragment(EventScorekeepingPanelTeamItemFragment, fragment);

  return (
    <Chip
      value={isChecked}
      onValueChange={() => {
        setValue('isEditing', false);
        setValue('selectedTeam', team);
      }}
      accessibilityLabel={team.title || 'Team'}
      size="md"
      style={style.container(isChecked)}
    >
      <Avatar
        id={team.avatar_id || ''}
        size="md"
        color={team.home_primary_color || ''}
        name={team.title || ''}
      />
    </Chip>
  );
}

const style = StyleSheet.create((theme) => ({
  container: (selected: boolean) => ({
    opacity: selected ? 1 : 0.5,
    padding: theme.size(0.5),
  }),
}));

export default EventScorekeepingPanelTeamItem;
